import { BrowserRouter, Route, Switch, Link } from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline"
import React,{useEffect} from 'react'
import axios from 'axios'
import Header from "./components/Header"
import Typical from 'react-typical'
import Hero from "./components/Hero";
import GetStarted from "./components/pages/GetStarted"
import Portfolio from "./components/pages/Portfolio"
import AboutUs from "./components/pages/AboutUs"
import ContactUs from "./components/pages/ContactUs"
import Error from "./components/pages/Error"
import Blog from "./components/pages/Blog"
import Project from "./components/pages/Project"
import Footer from "./components/Footer"
import News from "./components/News"
import { Button, CardActionArea, CardActions, Card, CardContent, CardMedia, Typography, Grid } from '@material-ui/core';







function App() {


  
  return (
    <BrowserRouter>
      <main className="wrapper">
        <Header /> 
        <Switch>
          <Route path="/" exact>
            <Hero />
          </Route>
          <Route path="/blog">
            <Blog />
          </Route>
          <Route path="/contact-us">
            <ContactUs />
          </Route>
          <Route path="/about-us">
            <AboutUs />
          </Route>
          <Route path="/get-started">
            <GetStarted />
          </Route>
          <Route path="/portfolio">
            <Portfolio />
          </Route>
          <Route path="/Project">
            <Project />
          </Route>
          <Route path="*">
            < Error />
          </Route>
        </Switch>
        {/* <Grid className="overlay2">
            <Typography variant='body' className="headings">News<span className="text-green-500">Technolog </span></Typography>
          </Grid> */}
        <News />
        <Footer />
      </main>
    </BrowserRouter>
  )
}

export default App;
